import { render, staticRenderFns } from "./MicroBase.vue?vue&type=template&id=dbb53752&scoped=true"
import script from "./MicroBase.vue?vue&type=script&lang=js"
export * from "./MicroBase.vue?vue&type=script&lang=js"
import style0 from "./MicroBase.vue?vue&type=style&index=0&id=dbb53752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb53752",
  null
  
)

export default component.exports